import React, { useEffect, useCallback, useState } from "react";
import { StyledInput } from "../style/global.style";
import FacebookLoginButton from "./FacebookLoginButton";

const SelectPixel = ({ accounts, accountIndex, setAccountIndex, pixelIndex, setPixelIndex, isEditMode, setShowEditMode, getAccounts, connectionFailed, disabled }) => {
	const [pixels, setPixels] = useState(isEditMode ? accounts[0]?.adspixels?.data : null);

	const setIndexes = useCallback(() => {
		if (isEditMode) return;
		setAccountIndex(0);
		setPixelIndex(0);
		setPixels(accounts[0]?.adspixels?.data);
	}, [accounts, isEditMode, setAccountIndex, setPixelIndex]);

	useEffect(() => {
		setIndexes();
	}, [setIndexes]);

	const renderAccount = () => {
		return (
			<StyledInput
				as="select"
				name="account"
				id="account"
				disabled={isEditMode || disabled}
				onChange={(e) => {
					setAccountIndex(e.target.value);
					setPixels(accounts[e.target.value]?.adspixels?.data);
				}}
				value={accountIndex}>
				{accounts && accounts.length ? (
					accounts.map((account, index) => (
						<StyledInput as="option" key={index} value={index}>
							{account.name} ({account.account_id})
						</StyledInput>
					))
				) : (
					<StyledInput as="option" key="none" value="none">
						no account to display
					</StyledInput>
				)}
			</StyledInput>
		);
	};
	const renderPixels = () => {
		return (
			<StyledInput
				as="select"
				name="pixel"
				id="pixel"
				disabled={isEditMode || disabled}
				onChange={(e) => {
					setPixelIndex(e.target.value);
				}}
				value={pixelIndex}>
				{pixels && pixels.length ? (
					pixels.map((pixel, index) => (
						<StyledInput as="option" key={index} value={index}>
							{pixel.name} ({pixel.id})
						</StyledInput>
					))
				) : (
					<StyledInput as="option" key="none" value="none">
						no pixel to display
					</StyledInput>
				)}
			</StyledInput>
		);
	};
	return (
		<>
			{renderAccount()}
			{renderPixels()}
			{isEditMode && (
				<FacebookLoginButton
					onSuccess={(e) => {
						setShowEditMode(false);
						getAccounts(e);
					}}
					onFail={connectionFailed}
					label="Edit"
					disabled={!pixels.length}
				/>
			)}
		</>
	);
};

export default SelectPixel;
